import React from 'react'
import { ButtonBookmark, ButtonLike } from '../../../components'

const ActionButtons = ({bookmarkable}) => {
  const [bookmarked, setBookmarked] = React.useState(false)
  const [liked, setLiked] = React.useState(false)

  const handleBookmark = () => {
    setBookmarked(!bookmarked)
  }

  const handleLike = () => {
    setLiked(!liked)
  }

  return (
    <div>
      <ButtonBookmark transparent thin={true} className="mb-5" onClick={handleBookmark} active={bookmarked} disabled={!bookmarkable}/>
      <ButtonLike transparent thin={true} className="mb-2" onClick={handleLike} active={liked}/>
      <p className="text-xs text-gray-444 text-center">Liked by 1,312</p>
    </div>
  )
}

export { ActionButtons }